import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
  token: '',
  type: '',
  username: ''
}
const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_TYPE: (state, type) => {
    state.type = type
  },
  SET_USERNAME: (state, username) =>{
    state.username = username
  }
}
const actions = {
  setToken({ commit }, token) {
    // Vue.ls.set('token', token)
    commit('SET_TOKEN', token)
  },
  setType({ commit }, type) {
    // Vue.ls.set('type', type)
    commit('SET_TYPE', type)
  },
  setUserName ({ commit }, username) {
    commit('SET_USERNAME', username)
  }
}
const getters = {
  token: state => state.token
}

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})

export default store
